import { createContext } from "react"
import {DataExplorerRowObj} from "../services/GetDataExplorer";

export type DataSelectorState = {  varName: undefined | string , deviceId: undefined | string | number, relevantDataset: DataExplorerRowObj[] | undefined }
const initialState: DataSelectorState = { varName: undefined, deviceId: undefined, relevantDataset: undefined }

export const DataSelectorContext = createContext(initialState)